/**
 * @description 會員有效契約狀態 (enum)
 */
export enum MemberValidContractStatusEnum {
  /** 有效契約會員 */
  Valid = 'V',
  /** 非有效契約會員 */
  Invalid = 'N'
}
